export default {
	//
	// Messages generated in API calls
	//

	//
	// goalAPI
	//
	createGoal_createError: "Attempted to create an existing goal.",
	createKeyResult_createError: "Attempted to create an existing key result.",
	queryKeyResult_goalIds_lengthError: "One or more goalIds are required to query for key results.",
	updateGoal_updateError: "Attempted to update a new goal.",
	updateKeyResult_updateError: "Attempted to update a new key result.",
	validateConfidenceLevels_invalidConfidenceLevel: "Invalid goal confidence level specified: {confidenceLevel}. Valid goal confidence levels: {validGoalConfidenceLevels}.",
	validateGoalTypes_invalidGoalType: "Invalid goal type specified: {goalType}. Valid goal types: {validGoalTypes}.",
};



// WEBPACK FOOTER //
// ./src/lang/en/api.js